import { NewJoinersAndAllocationsModalContext } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewJoinersAndAllocationsModal/NewJoinersAndAllocationsModal';
import { NewJoinersAndAllocationsPersonalDataCustomDetailEntry } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/NewJoinersAndAllocationsModal/useNewJoinersAndAllocationsModalController';
import { useContext, useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { CustomDetailDataTypeEnum } from '@dealstack/shared/lib/generated/models/CustomDetailDataTypeEnum.ts';
import { CustomDetailEnum } from '@dealstack/shared/lib/generated/models/CustomDetailEnum.ts';
import { useMipKycSetting } from '@dealstack/frontend/app/pages/Project/MIP/hooks/useKycSetting.ts';

export const useNewJoinersAndAllocationsPersonalDataController = () => {
	const { mipData, personalDataForm } = useContext(NewJoinersAndAllocationsModalContext);

	const { data: mipInvestorSettings } = useMipKycSetting(mipData?.id ?? '');

	const [isPersonalModalVisible, setIsPersonalModalVisible] = useState(false);
	const [isVehicleModalVisible, setIsVehicleModalVisible] = useState(false);

	const individualArrayX = useFieldArray({
		name: 'individual',
		control: personalDataForm.control,
	});
	const vehicleArrayX = useFieldArray({
		name: 'vehicle',
		control: personalDataForm.control,
	});
	personalDataForm?.watch();

	const onTagManagerModalClose = () => {
		setIsPersonalModalVisible(false);
		setIsVehicleModalVisible(false);
	};

	const onAddIndividualTag = () => {
		setIsPersonalModalVisible(true);
	};

	const onAddVehicleTag = () => {
		setIsVehicleModalVisible(true);
	};

	const nonFormCustomDetails = mipData?.customDetails?.filter(
		(item) =>
			item.dataType !== CustomDetailDataTypeEnum.FORM &&
			item.dataType !== CustomDetailDataTypeEnum.PRE_FILLABLE_FORM
	);

	const isInvestorBankAccountRequired: boolean =
		mipInvestorSettings?.isInvestorBankAccountRequired ?? false;

	const isTaxResidenceRequired: boolean = mipInvestorSettings?.isTaxResidenceRequired ?? false;

	const isTinRequired: boolean = mipInvestorSettings?.isTinRequired ?? false;

	const isPlaceOfBirthRequired: boolean = mipInvestorSettings?.isPlaceOfBirthRequired ?? false;

	const isCountryOfBirthRequired: boolean =
		mipInvestorSettings?.isCountryOfBirthRequired ?? false;

	const isEmployeeIdRequired: boolean = mipInvestorSettings?.isEmployeeIdRequired ?? false;
	const isCitizenshipRequired: boolean = mipInvestorSettings?.isCitizenshipRequired ?? false;

	const isVehicleBankAccountRequired: boolean =
		mipInvestorSettings?.isVehicleBankAccountRequired ?? false;

	const isControllingPartyInfoRequired: boolean =
		mipInvestorSettings?.isControllingPartyInfoRequired ?? false;

	const onUpdateCustomDetails = (
		type: CustomDetailEnum,
		data: NewJoinersAndAllocationsPersonalDataCustomDetailEntry[]
	) => {
		if (type === CustomDetailEnum.INDIVIDUAL) {
			individualArrayX.replace(data);
		} else {
			vehicleArrayX.replace(data);
		}
		onTagManagerModalClose();
	};
	const removeCustomDetailLocally = (type: CustomDetailEnum, localId?: string) => {
		const baseArray = type === CustomDetailEnum.INDIVIDUAL ? individualArrayX : vehicleArrayX;
		const indexToRemove = baseArray?.fields?.findIndex((item) => item.localId === localId);
		if (indexToRemove === undefined) {
			return;
		}
		const updatedVehiclesArray = [...(baseArray.fields ?? [])];
		updatedVehiclesArray.splice(indexToRemove, 1);
		(type === CustomDetailEnum.INDIVIDUAL ? individualArrayX : vehicleArrayX).replace(
			updatedVehiclesArray
		);
	};

	return {
		removeCustomDetailLocally,
		onUpdateCustomDetails,
		individualArray: individualArrayX.fields,
		vehiclesArray: vehicleArrayX.fields,
		nonFormCustomDetails,
		isVehicleBankAccountRequired,
		isControllingPartyInfoRequired,
		isTaxResidenceRequired,
		isTinRequired,
		isPlaceOfBirthRequired,
		isCountryOfBirthRequired,
		isEmployeeIdRequired,
		isCitizenshipRequired,
		isInvestorBankAccountRequired,
		personalDetailsForm: personalDataForm,
		isVehicleModalVisible,
		isPersonalModalVisible,
		onTagManagerModalClose,
		onAddIndividualTag,
		onAddVehicleTag,
	};
};
